module.exports = "data:image/png;base64,UklGRloBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSIUAAAABl6CokSQ1uAzHION+FxEBokSv7mt67q/TS4WCNpKUeWb0r5YtRPRfYdu2TfZO2jM4UFureKGMvQf5YBFHjiWIi3Uc02Jr0Jfd5wJcPUwZR6vVgFgkUXFMD3CSsn3egEjdmvYD6fvHQfpPCQj/GQTKH/9QggI4zeSKF9wofWtBwouMObMAAFZQOCCuAAAAEAQAnQEqEAAQAAIANCWUAnR/CP/iAyeIL8Y3gHoAfowfePdYLyX9WQAA/q0+wBf68NwcBmYWb59t535B/DPJr5ylrOZ52EaWgzexsdO7F3xT7hpvQPtHOjbjii1+YPaDxPbCu56Iil160FLuQ3jIgSVOzYh9NE00d68nJoKC8zGTp+HoFtZx888wFpr6FCjwsjA3Z4weEsTz6P3nmueL/DXjorygenJBYt6mlAAA"


//////////////////
// WEBPACK FOOTER
// ./src/Assets/icons/event.png
// module id = 26
// module chunks = 0